<template lang="html">
	<section class="block">
		<h3>{{ $t(`${sector}.${abast}.workers.title`) }}</h3>
		<p v-if="isReportEditable" class="note">{{ $t(`${sector}.${abast}.workers.desc`) }}</p>
		<emissions-table v-if="!skip" v-model="emissions" :editable="isReportEditable">
			<template v-slot:header>
				<th>{{ $t('report.table.concept') }}</th>
				<th>{{ $t('report.table.vehicle') }}</th>
				<th>
					<span :data-tooltip-alert="$t('tooltip.vehicle_vs_people')">
						<i class="mdi mdi-alert-circle icon icon--emphasis" />
					</span>
					{{ $t('report.table.qty') }}
				</th>
				<th>{{ $t('report.table.motorization') }}</th>
				<th>
					<span :data-tooltip-alert="$t('tooltip.km_vs_hour')">
						<i class="mdi mdi-alert-circle icon icon--emphasis" />
					</span>
					{{ $t('report.table.distance') }}
				</th>
			</template>
			<template v-slot:body="{ item }">
				<td>{{ item.concept }}</td>
				<td>{{ item.vehicle.label }}</td>
				<td>{{ item.mult }}<em class="unit">{{ vehicleUnit(item.vehicle) }}</em></td>
				<td>{{ item.resource.label }}</td>
				<td>{{ item.qty }}<em class="unit">{{ item.resource.unit }}</em></td>
			</template>
			<template v-slot:insert="{ insert }">
				<td>
					<input
						type="text"
						v-model="insert.concept"
						:placeholder="$t(`${sector}.${abast}.workers.example`)" />
				</td>
				<td>
					<dropdown-select
						:options="VEHICLES"
						v-model="insert.vehicle"
						:placeholder="$t('report.table.vehicle')" />
				</td>
				<td :data-tooltip="insert.vehicle
					? $t('tooltip.unit_in', { unit: vehicleUnit(insert.vehicle) })
					: $t('tooltip.require.vehicle')">
					<input
						v-model.number="insert.mult"
						:disabled="!insert.vehicle"
						:placeholder="insert.vehicle
							? vehicleUnit(insert.vehicle)
							: $t('report.table.qty')"
						type="number"
						min="0"
						step="1" />
				</td>
				<td :data-tooltip="insert.vehicle ? false : $t('tooltip.require.vehicle')">
					<dropdown-select
						v-model="insert.resource"
						:disabled="!insert.vehicle"
						:options="insert.vehicle ? insert.vehicle.emissions.distance : []"
						:placeholder="$t('report.table.motorization')" />
				</td>
				<td :data-tooltip="isEmpty(insert.resource)
					? $t('tooltip.require.motorization')
					: $t('tooltip.unit_in', { unit: insert.resource.unit })">
					<input
						v-model.number="insert.qty"
						:disabled="isEmpty(insert.resource)"
						:placeholder="isEmpty(insert.resource)
							? $t('report.table.distance')
							: insert.resource.unit"
						type="number"
						min="0"
						step="0.1" />
				</td>
			</template>
		</emissions-table>
		<p v-if="isSkipperVisible">
			<label>
				<input type="checkbox" v-model="skip" :disabled="!isReportEditable" />
				{{ $t('global.tip.skip') }}
			</label>
		</p>
	</section>
</template>

<script>
import StepBlockMixin from '@/mixins/StepBlockMixin';
import EmissionsTable from '@/components/EmissionsTable.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import { isEmpty } from '@/utils';
import VEHICLES from '@/assets/constants/vehicles';

export default {
	name: 'StepWorkers',
  keyBlock: 'workers',
	mixins: [StepBlockMixin],
	components: { EmissionsTable, DropdownSelect },
	data() {
		return { VEHICLES };
	},
	methods: {
		isEmpty,
		vehicleUnit(vehicle) {
			return vehicle.collective ? this.$t('global.default.people') : vehicle.unit;
		},
	},
};
</script>
